import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(timezone);
dayjs.extend(utc);

export const zonedDateToUtc = (date: string | number | dayjs.Dayjs | Date | undefined) => {
  const zonedDayjs = dayjs(date);
  const utcDayjs = dayjs.utc(zonedDayjs.format('YYYY-MM-DDTHH:mm:ss'));
  const isoFormat = utcDayjs.toISOString();
  return isoFormat;
};

export const utcDateToZoned = (date: string) => {
  const zonedDateString = date?.replace('Z', '');
  const zonedDayJS = dayjs.tz(zonedDateString, dayjs.tz.guess()).startOf('day');

  return zonedDayJS;
};

export const toIsoUtcDate = (val: any) => {
  if (typeof val === 'string' && val.endsWith('Z')) {
    return val;
  }

  const date = dayjs(val);
  if (!date.isValid()) return null;

  return new Date(Date.UTC(date.year(), date.month(), date.date(), 0, 0, 0, 0)).toISOString();
};

export const postDateHelper = (
  date?: string | number | dayjs.Dayjs | Date | undefined,
  short?: boolean,
  datePopper?: boolean,
  zoned?: boolean
) => {
  if (!date) {
    return dayjs().utc().format('YYYY-MM-DD') + 'T00:00:00.000Z';
  }

  if (short) {
    return dayjs.utc(date).format('YYYY-MM-DD');
  }

  if (datePopper) {
    return dayjs.utc(date).format('ddd MMM DD YYYY ') + '00:00:00 GMT+0000 (Greenwich Mean Time)';
  }

  if (zoned) {
    return zonedDateToUtc(date);
  }

  const res = dayjs.utc(date).format('YYYY-MM-DD') + 'T00:00:00.000Z';

  return res;
};

export const handleCalculateEndDate = (
  newStartDate: string,
  taskWorkDaysCount: number,
  companyWorkingDays: number[],
  addExtraDays?: number,
  asSringDate?: boolean
) => {
  let workDaysCount = Number(taskWorkDaysCount) < 0 ? 0 : Number(taskWorkDaysCount);

  if (!newStartDate) return null;

  const newChanged = utcDateToZoned(newStartDate);

  let addedDays = 0;
  let addedWorkingDays = 0;
  let changedDayIndex = newChanged.day();

  while (addedWorkingDays !== workDaysCount) {
    addedDays += 1;

    if ((changedDayIndex as any) === 7) {
      changedDayIndex = 0;
    }
    if (companyWorkingDays.includes(changedDayIndex)) {
      addedWorkingDays += 1;
    }
    changedDayIndex += 1;
  }

  let newEndDate = newChanged.add(addedDays - 1, 'day');

  while (!companyWorkingDays.includes(newEndDate.day())) {
    newEndDate = newEndDate.add(1, 'day');
  }

  if (!!addExtraDays) {
    newEndDate = newEndDate.add(addExtraDays, 'day');
  }

  if (asSringDate) {
    return newEndDate.toDate();
  }

  return newEndDate;
};

export function parseLocalDate(dateString: string) {
  const [year, month, day] = dateString.split('T')[0].split('-').map(Number);
  return new Date(year, month - 1, day, 0, 0, 0, 0);
}

export const calculateBusinessDays = (
  startDate: string,
  endDate: string,
  workingDays: number[]
) => {
  if (!startDate || !endDate) {
    return -1;
  }

  const isoStart = toIsoUtcDate(startDate);
  const isoEnd = toIsoUtcDate(endDate);

  var fromDay = new Date(isoStart);
  var toDay = new Date(isoEnd);
  var numOfWorkingDays = 1;

  fromDay.setHours(0, 0, 0, 0);
  toDay.setHours(0, 0, 0, 0);

  const workDaysFn = (day: number) => {
    if (workingDays?.some((item) => day === item)) {
      numOfWorkingDays = numOfWorkingDays + 1;
    }
  };

  while (fromDay < toDay) {
    fromDay.setDate(fromDay.getDate() + 1);
    var day = fromDay.getDay();

    workDaysFn(day);
  }

  return numOfWorkingDays;
};
